import { Box, Button, ButtonBase, Paper, Typography } from "@material-ui/core";
import useStyles from "./ProjectCard.styles";

type PropsType = {
  projectTitle: string,
  appType: string,
  defaultImage: string,
  onClick?: () => void;
}

function ProjectCard({
  projectTitle,
  appType,
  defaultImage,
  onClick,
}: PropsType){
  const classes = useStyles();
  return(
    <Paper elevation={4} className={classes.projectCardWarp}>
      <img src={defaultImage} alt="" className={classes.proImage} />
      <Box className={`${classes.proDetails} isActive`}>
        <Box className={classes.appInfo}>
        <Typography className={classes.proTitle}>{projectTitle}</Typography>
        <ButtonBase className={classes.appType}>{appType}</ButtonBase>
        <Button className={classes.detailBtn} onClick={onClick}>View Details</Button>
        </Box>
      </Box>
    </Paper>
  )
}

export default ProjectCard;
